export default "__VITE_ASSET__C4yk5xGi__"